// extracted by css-extract-rspack-plugin
export default {"popover":"HQ89UkptA4t_dDxS","emptyState":"kYCds20Tuxk6yeZc"};